import { Button, Box } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { Resources, useResource } from "Translations/Resources";

const RESOURCES = Resources.Components.Merchant.Facilities.Form.OpeningHours;

type Props = {
  onClick: () => void;
};

export const AddTimeRangeButton = ({ onClick }: Props) => {
  const { t } = useResource();

  return (
    <Box>
      <Button startIcon={<AddIcon />} onClick={onClick} size="small">
        {t(RESOURCES.AddTimeRange)}
      </Button>
    </Box>
  );
};
